import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { provideCalAngular } from '@cvx/cal-angular';
import { environment } from '../environments/environment';
import { authInterceptor } from './shared/interceptors/auth.interceptor';




import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAnimations(),
    provideHttpClient(withFetch()),
    provideRouter(routes),
    provideCalAngular(`assets/cal_env_config/cal.${environment.envName}.json`, 'AzureAD'),
        provideHttpClient(withInterceptors([authInterceptor]))

  ]
};
